import { connect } from 'react-redux'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { UploadField } from '@navjobs/upload'
import {
  Card,
  CircularProgress,
  Button,
  FontIcon,
  List,
  Subheader
} from 'react-md'

import { getArtworkUploadStatus } from 'redux/reducers'
import * as actions from 'redux/actions'

import './index.css'

class SelectFiles extends Component {
  constructor (props) {
    super(props)
    this.onFiles = this.onFiles.bind(this)
  }

  async onFiles (files) {
    const { artworkFilesReceive, history } = this.props
    artworkFilesReceive(files, history)
  }

  render () {
    const { artworkUploadStatus } = this.props

    const ListItem = ({ title, children }) => (
      <div className='select-footer-item md-list-item md-body-2'>
        <div className='md-text--primary'>
          { title }
        </div>
        <div className='md-text--secondary'>
          { children }
        </div>
      </div>
    )

    return (
      <Card>
        { artworkUploadStatus.processing ? (
          <div className='processing-artworks'>
            <CircularProgress id='processing-files-progress' scale={2} />
            <span className='md-title'>
              Processing files, please wait
            </span>
          </div>
        ) : (
          <UploadField
            onFiles={this.onFiles}
            uploadProps={{
              accept: '.jpg,.jpeg,.png',
              multiple: true
            }}
          >
            <div className='select-container'>
              <div className='md-headline select-header'>
                Upload your high-resolution JPG or PNG artwork file to get
                started
              </div>
              <div className='select'>
                <FontIcon forceFontSize forceSize={100}>file_upload</FontIcon>
                <div className='md-title'>Drag and drop files here</div>
                <div className='md-subheading-2'>or</div>
                <Button raised primary>
                  Select to Upload
                </Button>
              </div>
              <div className='select-footer'>
                <List>
                  <Subheader primaryText='Some things to consider:' />
                  <ListItem title='Image format'>
                    Upload the highest resolution file you have as a JPG or PNG.
                  </ListItem>
                  <ListItem title='File size'>
                    Max file size is 200 MB.
                  </ListItem>
                  <ListItem title='Having trouble?'>
                    If you need help uploading, refer to the seller guide or
                    contact us.
                  </ListItem>
                  <ListItem title='Rights'>
                    You must own all rights to any images uploaded, have valid
                    rights to these images, or be otherwise authorised to
                    upload these images on the arthaus platform. By uploading
                    you agree to this.
                  </ListItem>
                </List>
              </div>
            </div>
          </UploadField>
        ) }
      </Card>
    )
  }
}

SelectFiles.propTypes = {
  artworkUploadStatus: PropTypes.object.isRequired
}

const mapStateToProps = (state) => ({
  artworkUploadStatus: getArtworkUploadStatus(state)
})

export default connect(mapStateToProps, actions)(SelectFiles)



// WEBPACK FOOTER //
// ./src/containers/SelectFiles/index.js